export type RolePermissionsType = {
  code: string
  name: string
  description: string
}

export type RoleTabsPermissionsType = {
  code: string
  name: string
}

export type RoleNotificationPermissionsType = {
  code: string
  name: string
}

export type RoleStatusSubscriptionScheduleType =
  | 'instant'
  | 'interval'
  | 'daily'
  | 'weekly'
  | 'monthly'

export type RoleStatusSubscriptionSchedule = {
  type: RoleStatusSubscriptionScheduleType
  interval_minutes?: number
  at_time?: string
  weekdays?: number[]
  month_day?: number
}

export type RoleStatusSubscription = {
  object_type_id: number
  status_triggers: string[]
  is_active: boolean
  schedule: RoleStatusSubscriptionSchedule
}

export type TypePermission = {
  object_type_id: number
  read: boolean
  create: boolean
  update: boolean
  delete: boolean
  relocate: boolean
}

export type PassportPermission = {
  object_type_id: number
  read: boolean
  update: boolean
}

export type RoleType = {
  id: number
  name: string
  group_id: number
  permissions: string[]
  tabs_preset: string[]
  notification_preset?: string[] // пресет для пользователей этой роли (уведомления по умолчанию)
  status_subscription_defaults?: RoleStatusSubscription[] // дефолтные подписки на статусы для роли
  type_permissions?: TypePermission[]
  element_permissions?: TypePermission[]
  passport_permissions?: PassportPermission[]
}

export enum MapLayerPermissions {
  ALTERNATIVE_MAP = 'ALTERNATIVE_MAP',
  SCHEME = 'SCHEME',
  SATELLITE = 'SATELLITE',
  HYBRID = 'HYBRID',
}
